import React from 'react';
import { FaTimes, FaCheckCircle } from 'react-icons/fa';

interface TestCompleteConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isMobile?: boolean;
}

const TestCompleteConfirmModal: React.FC<TestCompleteConfirmModalProps> = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  isMobile = false 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className={`relative ${isMobile ? 'w-[90%] max-w-sm' : 'w-full max-w-md'} mx-4`}>
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 px-6 py-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <FaCheckCircle className="text-white text-xl" />
                <h3 className="text-white font-semibold text-lg">Sınavı Bitir</h3>
              </div>
              <button
                onClick={onClose}
                className="p-1 rounded-lg hover:bg-white/20 transition-colors"
                aria-label="Kapat"
              >
                <FaTimes className="text-white text-lg" />
              </button>
            </div>
          </div>
          
          {/* Content */}
          <div className="p-6">
            <p className="text-gray-700 dark:text-gray-300 text-center mb-6">
              Sınavı bitirmek istediğinizden emin misiniz?
            </p>
            
            {/* Buttons */}
            <div className="flex gap-3">
              <button
                onClick={onClose}
                className="flex-1 px-4 py-3 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 rounded-lg font-medium transition-colors"
              >
                İptal
              </button>
              <button
                onClick={onConfirm}
                className="flex-1 px-4 py-3 bg-blue-500 hover:bg-blue-600 text-white rounded-lg font-medium transition-colors shadow-sm hover:shadow-md"
              >
                Bitir
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestCompleteConfirmModal;